import {Dimensions} from './dimensions'

export const DEFAULT_DIMENSIONS_DATA: Dimensions = {
    height: undefined,
    width: undefined,
}
